import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Button, FormGroup, Spinner, Label } from "reactstrap";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { actions as actionsSite } from "../../redux/actions/site";
import Validation from "../../utils/validation";
import { currencyToFloat, formatCurrency } from "../../utils/converts";
import BaseService from "../../services/baseService";
import Success from "../../components/messagesModal/success";
import Error from "../../components/messagesModal/error";
import FieldCustom from "../../components/form/fieldCustom";

const baseService = new BaseService("ondemand-log-query");
const ModalApprove = ({ row }) => {
  const [loading, setLoading] = useState(false);
  const [balanceChain, setBalanceChain] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      const res = await baseService._get(`transaction-account/balance/${row.client}`);
      setBalanceChain(res.currentBalanceChain);
      setLoading(false);
    }
    run();
  }, []);

  new Validation(Yup);
  const initialValues = {
    price: Number.isInteger(row.price) ? (row.price.toFixed(2)).replace(".",",") : row.price,
    finalPrice: Number.isInteger(row.price) ? (row.price.toFixed(2)).replace(".",",") : row.price,
    balanceChain: Number.isInteger(balanceChain) ? (balanceChain.toFixed(2)).replace(".",",") : balanceChain
  };

  const validationSchema = Yup.object().shape({
    finalPrice: Yup.string().required("Preço é obrigatório").valorMoedaMaiorQueZero("Precisa ser maior que 0,00")
  });

  const save = async (data) => {
    const payload = {
      finalPrice: currencyToFloat(data.finalPrice),
      userWhoApproved: row.user._id,
      status: "Processando"
    }

    const res = await baseService.put(row._id, payload);

    const configModal = {
      component: res.error ? <Error msg={res.msg} /> : <Success msg={'Status da consulta alterado para "Processando"'} />,
      title: res.error ? `Erro` : `Sucesso`,
    };
    dispatch(actionsSite.closeModal());
    dispatch(actionsSite.setModal(configModal));
  };

  return (
    <Row>
      <Col md="12">
        {loading ? (
          <div className="text-center">
            <Spinner color="danger" />
          </div>
        ) : (
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={async (values) => await save(values)}>
            {({ status, isSubmitting }) => (
              <Form>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label>Preço Cadastrado</Label>
                      <Field component={FieldCustom} convert={formatCurrency} name="price" disabled="disabled"/>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label>Saldo do cliente</Label>
                      <Field component={FieldCustom} convert={formatCurrency} name="balanceChain" disabled="disabled"/>
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <Label>Preço de venda</Label>
                      <Field component={FieldCustom} convert={formatCurrency} name="finalPrice"/>
                    </FormGroup>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end mt-3">
                  <Button type="submit" color="primary" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <Spinner color="light" size="sm" className="mr-1"/>
                        Processando...
                      </>
                      ) : (
                      <>
                        <i className="fa-solid fa-floppy-disk mr-1"></i>
                        Salvar
                      </>
                    )}
                  </Button>
                </div>
                {status && <div className={"alert alert-danger"}>{status}</div>}
              </Form>
            )}
          </Formik>
        )}
      </Col>
    </Row>
  );
};

export default ModalApprove;
